"use client";
import { useId, useState } from "react";
import MockFooter from "@/mock/footer";
import { Tab } from "@headlessui/react";
import classnames from "classnames";

import FooterTabPanel from "components/footer-tab-panel";

import styles from "./styles.module.css";

const FooterTabWrapper = () => {
  const id = useId();
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <Tab.Group onChange={(e) => setSelectedTab(e)}>
      <Tab.List className={styles.tabList}>
        {MockFooter.categories.map((category, index) => (
          <Tab
            key={`${id}+${index}`}
            className={({ selected }) => `${styles.tab} ${selected ? styles.tabselected : styles.tabnotselected}`}
          >
            {category?.name}
          </Tab>
        ))}
      </Tab.List>
      <div className={styles.tabPanels}>
        {MockFooter.categories.map((category, index) => (
          <div
            key={`${index}${id}`}
            className={classnames(styles.tabContentWrap, { [styles.tabContentWrapSelected]: index === selectedTab })}
          >
            <FooterTabPanel categories={category?.subCategories} />
          </div>
        ))}
      </div>
    </Tab.Group>
  );
};

FooterTabWrapper.propTypes = {};

export default FooterTabWrapper;
